import React from "react";
import styled from "@emotion/styled"

const TicketButton = styled.button`
    margin: 0;
    margin-left: 0.25rem;
    padding: 1rem;
    border: none;
    text-align: center;
    font-size: 1.25rem;
    color: #faf2f0;
    position: relative;
    overflow: hidden;
    -webkit-tansition: .3s;
    -o-transition: .3s;
    transition: .3s;
    border-radius: 10px;
    background-color: #100504;

    &:after {
        position: absolute;
        -webkit-tansition: .3s;
        -o-transition: .3s;
        transition: .3s;
        content: '';
        width: 0;
        left: 50%;
        bottom: 0;
        height: 5px;
        background: #d6756c;
    }

    &:hover {
        cursor: pointer;

        &:after {
            width: 100%;
            left: 0;
        }
    }

    @media (max-width: 768px) {
       font-size: 1.2rem; 
    }

    
    @media (max-width: 425px) {
        padding: 0.6rem;
        line-height: 1rem;
        font-size: 0.9rem;
    }

    @media (max-width: 320px) {
        font-size: 0.8rem;
        padding: 0.5rem;
    }
`

const ticketButton = () => {
    return (
        <TicketButton>Purchase Tickets</TicketButton>
    )
}

export default ticketButton